import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { takeAfterAuth } from "@/components/CouponOfDay";
import { GOOGLE_STATE_KEY, googleRedirectUri } from "@/pages/Login";

// Ritorno dal login Google (progetto Readoo): /auth/google?code=...&state=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleOAuthCallback() {
  const navigate = useNavigate();
  const { completeGoogleCode } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const p = new URLSearchParams(window.location.search);
    const code = p.get("code");
    const expected = sessionStorage.getItem(GOOGLE_STATE_KEY);
    sessionStorage.removeItem(GOOGLE_STATE_KEY);
    const fail = (msg) => { setError(msg); setTimeout(() => navigate("/login", { replace: true }), 2200); };
    if (p.get("error")) return fail("Accesso con Google annullato");
    if (!code || !expected || p.get("state") !== expected) return fail("Sessione di accesso non valida, riprova");
    completeGoogleCode(code, googleRedirectUri())
      .then((user) => {
        toast.success(`Benvenuto${user?.first_name ? ", " + user.first_name : ""}!`);
        navigate(takeAfterAuth() || "/", { replace: true });
      })
      .catch((e) => fail(e.message || "Accesso con Google non riuscito"));
  }, [completeGoogleCode, navigate]);

  return (
    <div data-testid="google-oauth-callback" className="min-h-[70vh] flex flex-col items-center justify-center gap-4 px-6 text-center">
      {error ? <p className="text-bad text-sm">{error}</p> : (
        <>
          <Loader2 size={30} className="animate-spin text-brand" />
          <p className="text-subtle text-sm font-mono">Accesso in corso…</p>
        </>
      )}
    </div>
  );
}
